export const Logo = () => (
    <svg width={69} height={69} fill="none" xmlns="http://www.w3.org/2000/svg">
        <g clipPath="url(#a)">
            <g clipPath="url(#b)">
                <mask
                    id="c"
                    style={{ maskType: "luminance" }}
                    maskUnits="userSpaceOnUse"
                    x={-10}
                    y={-1}
                    width={268}
                    height={71}
                >
                    <path d="M257.997-.669H-9.257V69.67h267.254V-.669Z" fill="#fff" />
                </mask>
                <g mask="url(#c)">
                    <mask
                        id="d"
                        style={{ maskType: "luminance" }}
                        maskUnits="userSpaceOnUse"
                        x={-10}
                        y={-1}
                        width={268}
                        height={71}
                    >
                        <path d="M257.997-.669H-9.257V69.67h267.254V-.669Z" fill="#fff" />
                    </mask>
                    <g mask="url(#d)">
                        <mask
                            id="e"
                            style={{ maskType: "luminance" }}
                            maskUnits="userSpaceOnUse"
                            x={-1}
                            y={-1}
                            width={71}
                            height={71}
                        >
                            <path d="M69.893-.669H-.445V69.67h70.338V-.669Z" fill="#fff" />
                        </mask>
                        <g
                            mask="url(#e)"
                            fillRule="evenodd"
                            clipRule="evenodd"
                            fill="#AD864D"
                        >
                            <path d="M34.724 66.064c17.433 0 31.564-14.131 31.564-31.564 0-17.432-14.131-31.564-31.564-31.564C17.292 2.936 3.16 17.068 3.16 34.5c0 17.432 14.132 31.564 31.564 31.564ZM68.692 34.5c0 18.76-15.208 33.968-33.968 33.968C15.964 68.468.757 53.26.757 34.5.757 15.74 15.965.533 34.724.533c18.76 0 33.968 15.208 33.968 33.967Z" />
                            <path d="M48.664 34.728a1.202 1.202 0 0 1-1.202-1.203v-5.906c0-1.308-1.322-2.2-2.534-1.71l-8.531 3.456a4.242 4.242 0 0 1-3.185 0L24.68 25.91a1.843 1.843 0 0 0-2.534 1.71v2.858c0 1.019.825 1.845 1.843 1.845h19.147a1.202 1.202 0 0 1 0 2.406H23.989a4.248 4.248 0 0 1-4.246-4.251v-2.858c0-3.014 3.047-5.07 5.839-3.94l8.531 3.456c.443.18.939.18 1.382 0l8.532-3.456c2.791-1.13 5.838.926 5.838 3.94v5.906c0 .664-.538 1.203-1.201 1.203ZM18.223 37.615c.664 0 1.202.539 1.202 1.203v2.567c0 1.019.825 1.844 1.842 1.844h27.158a1.603 1.603 0 0 0 0-3.208h-24.4a1.202 1.202 0 0 1 0-2.406h24.4a4.008 4.008 0 0 1 4.006 4.01 4.008 4.008 0 0 1-4.006 4.01H21.267a4.248 4.248 0 0 1-4.245-4.25v-2.567c0-.664.538-1.203 1.201-1.203Z" />
                        </g>
                    </g>
                </g>
            </g>
        </g>
        <defs>
            <clipPath id="a">
                <path fill="#fff" d="M0 .2h69V68.8H0z" />
            </clipPath>
            <clipPath id="b">
                <path fill="#fff" d="M0 .2h258.458V68.8H0z" />
            </clipPath>
        </defs>
    </svg>
)